import { useContext, useCallback } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useQueries } from "react-query";
import { MediaMetaData } from "../shared/interfaces/Result";
import { getMimeTypeByFilename } from "../shared/helpers/MimeTypes/mimetypes";

export function useMediaByDataPointIdAndFilepath(
  mediaMetaData: MediaMetaData[],
  callbacks?: QueryCallbacks<MediaMetaData>,
) {
  const apiContext = useContext(ApiContext);

  const queryFunction = useCallback(
    async (mediaMetaData: MediaMetaData) => {
      return await apiContext.utp2FilesAPIs
        .getMediaByDataPointIdAndFilepath(mediaMetaData.DataPointId, mediaMetaData.MediaFilePath)
        .then((response) => {
          const url = URL.createObjectURL(response);
          const mimeType = getMimeTypeByFilename(mediaMetaData.MediaFilePath);

          return { ...mediaMetaData, url, mimeType };
        });
    },
    [apiContext.utp2FilesAPIs],
  );

  return useQueries(
    mediaMetaData.map((item) => ({
      queryKey: ["MediaByDataPointIdAndFilepath", item],
      queryFn: () => queryFunction(item),
      refetchOnWindowFocus: false,
      ...callbacks,
    })),
  );
}
